import styled from 'styled-components';
import {theme} from '@styles/theme';

export const PageSubtitleBlockWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 24px;
  background-color: ${theme.colors.accent02};
`;

export const PageSubtitleLeftWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 24px;
`;

export const PageSubtitleRightWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
`;

export const PageSubtitleLegendWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const PageSubtitleLegendMark = styled.div<{color: string}>`
  width: 7px;
  height: 7px;
  border: 1px solid ${theme.colors.basic08};
  border-radius: 36px;
  background-color: ${({color}) => (color ? color : theme.colors.basic08)};
`;
